module.exports = __webpack_public_path__ + "static/media/atharva_marathe.cfc82e4a.jpg";